import { __decorate } from "tslib";
import { AutoEncoder, BooleanDecoder, field, StringDecoder } from '@simonbackx/simple-encoding';
export class VerifyEmailRequest extends AutoEncoder {
}
__decorate([
    field({ decoder: StringDecoder })
], VerifyEmailRequest.prototype, "token", void 0);
__decorate([
    field({ decoder: StringDecoder })
], VerifyEmailRequest.prototype, "code", void 0);
export class PollEmailVerificationRequest extends AutoEncoder {
}
__decorate([
    field({ decoder: StringDecoder })
], PollEmailVerificationRequest.prototype, "token", void 0);
export class PollEmailVerificationResponse extends AutoEncoder {
}
__decorate([
    field({ decoder: BooleanDecoder })
], PollEmailVerificationResponse.prototype, "valid", void 0);
//# sourceMappingURL=VerifyEmailRequest.js.map